module.exports = __webpack_public_path__ + "static/media/NICE_Step3a_Image4.cb473ea0.jpg";